import { useEffect } from "react";
import { business } from "@/business-config";
const origin = () => business.seo.baseUrl || window.location.origin;
function setMeta(attr, key, value) {
  let el = document.head.querySelector("meta[" + attr + '="' + key + '"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}
export default function Seo({
  title,
  description,
  path = "/",
  jsonLd = null,
  noindex = false,
}) {
  useEffect(() => {
    const fullTitle = title
      ? title + " | " + business.seo.siteName
      : business.seo.defaultTitle;
    const desc = description || business.seo.defaultDescription;
    const url = new URL(path, origin()).href;
    const image = new URL(business.seo.ogImage, origin()).href;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex,follow" : "index,follow");
    for (const [key, value] of Object.entries({
      title: fullTitle,
      description: desc,
      url,
      image,
      type: "website",
      locale: "ro_RO",
    }))
      setMeta("property", "og:" + key, value);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    document.getElementById("business-jsonld")?.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.id = "business-jsonld";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => document.getElementById("business-jsonld")?.remove();
  }, [title, description, path, jsonLd, noindex]);
  return null;
}
export function buildLocalBusinessJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    name: business.legalName,
    image: new URL(business.seo.ogImage, origin()).href,
    url: origin(),
    telephone: business.phone.tel,
    address: {
      "@type": "PostalAddress",
      streetAddress: business.address.street,
      addressLocality: business.address.city,
      addressRegion: business.address.county,
      addressCountry: "RO",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: business.address.coords.lat,
      longitude: business.address.coords.lng,
    },
    hasMap: business.address.mapsUrl,
  };
}
